/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetBotStrategiesOptions, GetBotStrategiesResponses } from '../types/GetBotStrategies'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Get a list of all bot strategies. Admin-only.
 * @summary Get all bot strategies
 * {@link /v1/bot/strategies}
 */
export function getBotStrategies<ThrowOnError extends boolean = true>(
  options: Options<GetBotStrategiesOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetBotStrategiesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/bot/strategies',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetBotStrategiesResponses, ThrowOnError>>,
  )
}
